import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How Draft got me to pay for a free product",
  "description": "",
  "published": "2013-05-21T00:00:00.000Z",
  "redirect_from": ["/blog/how-draft-got-me-to-pay-for-a-free-product/swizec/6186"],
  "categories": "Freewriting, Nathan Kontny, Subscription business model, WordPress, Writer Resources, Writing, Writing",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "https://draftin.com/"
      }}>{`Draft`}</a>{` is a marvelous new webservice for writing. A bit like iA Writer, but for the browser.`}</p>
    <p>{`I `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/stypi-the-perfect-blogging-tool/swizec/3312"
      }}>{`love`}</a>{` `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/cool-thing-thursday-ia-writer/swizec/5517"
      }}>{`distraction-free`}</a>{` writing and I've recently come to rely on Draft for writing my blog posts. It's simply the best writing tool out there that I can use with my `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/cool-thing-thursday-a-300-euro-keyboard/swizec/5690"
      }}>{`fancy keyboard`}</a>{` (linux, no iA Writer, bad wrists).`}</p>
    <p>{`But I'm not here today to talk about the marvelous version control features, the fact I can click the equivalent of "Save back to `}<a parentName="p" {...{
        "href": "http://wordpress.org",
        "title": "WordPress"
      }}>{`WordPress`}</a>{`" when I'm done writing, or even the "Get feedback from an expert" feature.`}</p>
    <p>{`No, today I want to tell you about the brilliant trick Nathan Kontny used to convert me from a freeloader to the proud owner of a $4 monthly subscription.`}</p>
    <p>{`I login one day, right from the WordPress dashboard (Chrome extension), and what do I see if not a big pop up sort of thing saying "Hey, you should totally subscribe!". As a geek and a nerd I find these things tacky, overdone, and rather pushy.`}</p>
    <p>{`But this was different. There was no blackout, no flashing colours, just a friendly message from the founder saying "Hey, I'm making this thing and I need your help to keep it awesome.". More importantly, `}<em parentName="p">{`he started a conversation`}</em>{`!`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/c89bJzgRlerjCMR6C1ME",
        "alt": "Draft asks me to sign up"
      }}></img></p>
    <p>{`Sidenote: Wow, I was just delighted by how easy inserting an image is. Shift+Ctrl+I, drag image into browser. Beautiful.`}</p>
    <p><em parentName="p">{`khem`}</em></p>
    <p>{`See, it's not a pushy sales thing, it's an honest ask. If you don't want to, that's fine too, but please tell me why.`}</p>
    <p>{`I was instantly convinced.`}</p>
    <p>{`Left a message saying how awesome I find the service and `}<em parentName="p">{`how infinitely brilliant is the fact I can reply to a "please subscribe message"`}</em>{`. Later that day I kept my promise and subscribed.`}</p>
    <p>{`Better still, later that day I got a reply.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/agNbhVprQoSZAjZaeIau",
        "alt": "Draft replies"
      }}></img></p>
    <p>{`You have no idea how delighted I am by this little exchange. And now I'm spending $4 a month on something I use maybe twice a week for maybe an hour to indulge in what is a glorified hobby.`}</p>
    <p>{`In comparison, I pay $5 a month for `}<a parentName="p" {...{
        "href": "http://www.toggl.com",
        "title": "Toggl.com"
      }}>{`Toggl`}</a>{` - the basis of thousands of dollars worth of invoices, I use `}<a parentName="p" {...{
        "href": "http://github.com",
        "title": "GitHub"
      }}>{`Github`}</a>{` daily and don't pay a dime ... actually I don't pay for most things I spend my whole days on.`}</p>
    <p>{`Good job Draft, you're doing something right. This is probably the biggest bang for buck a service has ever gotten out of me.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=5f8cc117-11b3-4973-8d8d-8481e1aec05b",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      